import React from 'react'
import { Image } from 'react-bootstrap';

function AppImage(props) {
    return (
        <>
            <Image  {...props} draggable="false" onContextMenu={(e) => e.preventDefault()} />
        </>
    )
}

export default AppImage;